import { project2BaseUrl } from "./remoteClient";

export async function requestAssessmentMethods(token) {
    return await project2BaseUrl.get('administration/getAssessmentMethods', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}
